const getSavedState = (key) => {
  return JSON.parse(window.localStorage.getItem(key));
};

export { getSavedState };
